import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  trigger: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}))
